import axios, { AxiosResponse } from 'axios';

/**
 * Получение данных от нац. банка
 */
export const getAllRates = (): Promise<AxiosResponse> => {
    return axios.get('/rss/rates_all.xml');
};

/**
 * Расчет индивидуального подоходного налога
 */
export const calculateCustomsPayments = (data: any): Promise<AxiosResponse> => {
    return axios.post('/services/isnaportal/open-api/calculator/calculate-customs-payments', data);
};

